import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-resize-5",
  "use": "icon-si-glyph-arrow-resize-5-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-resize-5\" id=\"icon-si-glyph-arrow-resize-5\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1213</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M14.988,0 L10.011,0 C9.452,0 8.999,0.451 8.999,1.009 L10.579,2.584 L2.599,10.565 L1.029,9 C0.472,9 0.02,9.45 0.02,10.006 L0.02,14.952 C0.02,15.507 0.472,15.958 1.029,15.958 L5.991,15.958 C6.549,15.958 7,15.507 7,14.952 L5.418,13.375 L13.398,5.395 L14.988,6.98 C15.547,6.98 16,6.528 16,5.971 L16,1.009 C16,0.451 15.547,0 14.988,0 L14.988,0 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-resize-5.svg
// module id = SP2/
// module chunks = 62